<ng-container *ngIf="this.is_primary_provider">
    <footer class="">
        <div class="footer-container-section bg-blue">
            <div class="container-fluid d-flex flex-column footerc">
                <div class="container my-3">
                    <div class="footer-download-section">
                        <div class="row py-4 px-3">
                            <div class="col-12">
                                <div class="row downloade-app">
                                    <div class="col-sm-12 col-md-6">
                                        <h2 class="egd-theme-text font-weight-bolder heading3 mt-3 ml-3">Download
                                            eGlobalDoctors App Now</h2>
                                    </div>
                                    <div class="col-sm-12 col-md-6 d-flex justify-content-around text-center ">
                                        <div class="row">
                                            <div class="col-sm-12 col-lg-6 mx-auto my-3">
                                                <a href="https://play.google.com/store/apps/details?id=com.client.eglobaldoctors"
                                                    target="_blank">
                                                    <img class="app-img" height="50px"
                                                        src="assets/images/footer-logos/google-play-store.png"
                                                        alt="Online Consultation">
                                                </a>
                                            </div>
                                            <div class="col-sm-12 col-lg-6 mx-auto my-3">
                                                <a href="https://apps.apple.com/app/eglobaldoctors/id1557953741"
                                                    target="_blank">
                                                    <img class="app-img" height="50px"
                                                        src="assets/images/footer-logos/app-store.png"
                                                        alt="appstoreImage" alt="healthcare">
                                                </a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12 col-lg-4">

                                    <div class="text-center">
                                        <a href="./">
                                            <img class="my-3 min-width-250px max-width-400px p-2 bg-light rounded-pill"
                                                src="assets/images/footer-logos/footer_egd_logo.png"
                                                alt="eGlobalDoctors - Online Doctor Consultation">
                                        </a>
                                        <div class="">
                                            <img class="w-20 mt-4" height="100px"
                                                src="assets/images/footer-logos/eGlobalDoctors_QR.png"
                                                alt="Quality Health">
                                        </div>
                                    </div>

                                </div>
                                <div class="col-sm-12 col-lg-8">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-3 col-lg-3">
                                            <div class="lead mt-2">
                                                <h3>Company</h3>
                                            </div>
                                            <div class="row pl-md-1">
                                                <div class="footer-list-section mr-md-5 ml-md-1">
                                                    <li>
                                                        <a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','aboutus','_self');">
                                                            About Us
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','view-doctors','_self');">
                                                            Our Doctors
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','aboutus#our-mission','_self');">
                                                            Our Mission
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','#our-partners','_self');">
                                                            Our Partners
                                                        </a>
                                                    </li>
                                                    <li *ngIf="!this.is_uk_country">
                                                        <a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','leadership','_self');">
                                                            Leadership
                                                        </a>
                                                    </li>
                                                    <li><a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','terms-of-use','_self');">
                                                            Terms of Use
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','privacy-policy','_self');">
                                                            Privacy Policy
                                                        </a>
                                                    </li>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="col-sm-12 col-md-3 col-lg-3">
                                            <div class="lead  mt-2">
                                                <h3>Learn more</h3>
                                            </div>
                                            <div class="row">
                                                <div class="footer-list-section mr-md-5 ml-md-1">
                                                    <li>
                                                        <a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','view-specialties','_self');">
                                                            Our Specialties
                                                        </a>
                                                    </li>
                                                    <li *ngIf="!this.is_uk_country">
                                                        <a href="javascript:void(0)"
                                                            (click)="openLink('BLOGS_BASE_URL','','_self');"
                                                            href="javascript:void(0)">
                                                            Blogs
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','howitworks','_self');">
                                                            How it Works
                                                        </a>
                                                    </li>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <div class="lead  mt-2">
                                                <h3>Social</h3>
                                            </div>
                                            <div class="row">
                                                <div class="footer-list-section ml-md-1">
                                                    <li class="d-flex">
                                                        <img class="footer-social-logos my-auto"
                                                            src="assets/images/social_icons/whatsapp.png" alt="">
                                                        <a class="my-auto footer-social-label"
                                                            rel="noopener noreferrer nofollow"
                                                            href="https://api.whatsapp.com/send?phone=16102458765&app=facebook&entry_point=page_cta&fbclid=IwAR1MEiDbyA8J42x5LpNUSweMm1NTgDy5JYfLA0DCtVgnLGVHlTPU5GF2vfg"
                                                            target="_blank" *ngIf="!this.is_uk_country">
                                                            Whatsapp
                                                        </a>
                                                        <a class="my-auto footer-social-label"
                                                            rel="noopener noreferrer nofollow"
                                                            href="https://wa.me/447599422048"
                                                            target="_blank" *ngIf="this.is_uk_country">
                                                            Whatsapp
                                                        </a>
                                                    </li>
                                                    <li class="d-flex" *ngIf="!this.is_uk_country">
                                                        <img class="footer-social-logos my-auto"
                                                            src="assets/images/social_icons/facebook.png" alt="">
                                                        <a class="my-auto footer-social-label"
                                                            rel="noopener noreferrer nofollow"
                                                            href="https://www.facebook.com/eGlobalDoctors"
                                                            target="_blank">
                                                            Facebook
                                                        </a>
                                                    </li>
                                                    <li class="d-flex" *ngIf="!this.is_uk_country">
                                                        <img class="footer-social-logos my-auto"
                                                            src="assets/images/social_icons/twitter.png" alt="">
                                                        <a class="my-auto footer-social-label"
                                                            rel="noopener noreferrer nofollow"
                                                            href="https://twitter.com/eglobaldoctors" target="_blank">
                                                            Twitter
                                                        </a>
                                                    </li>
                                                    <li class="d-flex" *ngIf="!this.is_uk_country">
                                                        <img class="footer-social-logos my-auto"
                                                            src="assets/images/social_icons/linkedin.png" alt="">
                                                        <a class="my-auto footer-social-label"
                                                            rel="noopener noreferrer nofollow"
                                                            href="https://www.linkedin.com/company/eglobaldoctors"
                                                            target="_blank">
                                                            LinkedIn
                                                        </a>
                                                    </li>
                                                    <li class="d-flex" *ngIf="!this.is_uk_country">
                                                        <img class="footer-social-logos my-auto"
                                                            src="assets/images/social_icons/youtube.png" alt="">
                                                        <a class="my-auto footer-social-label"
                                                            rel="noopener noreferrer nofollow"
                                                            href="https://www.youtube.com/channel/UCn9m8kodFoGIygu8jX6gg3Q"
                                                            target="_blank">
                                                            YouTube
                                                        </a>
                                                    </li>
                                                    <li class="d-flex" *ngIf="!this.is_uk_country">
                                                        <img class="footer-social-logos my-auto"
                                                            src="assets/images/social_icons/instagram.png" alt="">
                                                        <a class="my-auto footer-social-label"
                                                            rel="noopener noreferrer nofollow"
                                                            href="https://www.instagram.com/eglobaldoctors/"
                                                            target="_blank">
                                                            Instagram
                                                        </a>
                                                    </li>
                                                    <li class="d-flex" *ngIf="!this.is_uk_country">
                                                        <img class="footer-social-logos my-auto"
                                                            src="assets/images/social_icons/pinterest.png" alt="">
                                                        <a class="my-auto footer-social-label"
                                                            rel="noopener noreferrer nofollow"
                                                            href="https://pin.it/4UVpXuU" target="_blank">
                                                            Pinterest
                                                        </a>
                                                    </li>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                            <div class="lead  mt-2">
                                                <h3>Contact Us</h3>
                                            </div>
                                            <div class="row">
                                                <div class="footer-list-section ml-md-2">
                                                    <li><a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','contactus','_self');">
                                                            Phone
                                                        </a></li>
                                                    <li><a href="javascript:void(0)"
                                                            (click)="openLink('HOMPAGE_BASE_URL','contactus','_self');">
                                                            Email
                                                        </a></li>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 mt-5 ffooter">
                                            <p class="lead m-auto font-weight-bold mt-5">
                                                <span>{{this.year}}</span>
                                                Copyright <span>&#169;</span>
                                                All rights reserved by <a class="egdlink" href="javascript:void(0)"
                                                    (click)="openLink('HOMPAGE_BASE_URL','','_self');">eGlobalDoctors</a>
                                            </p>

                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </footer>
</ng-container>